module.exports = __webpack_public_path__ + "img/header-img.fab1c698.svg";